export const dynamic = 'force-dynamic'
import React from 'react'
import { Metadata } from 'next';
import urls from '@/utils/urls/urls';
import cl from '@/utils/console/cl';
import AnimationWrapper from '@/components/AnimationWrapper/AnimationWrapper';

export const metadata: Metadata = {
  title: 'Gallery | TEX EXCELLENCE LIMITED',
  description: 'Gallery | TEX EXCELLENCE LIMITED',
}

export default async function GalleryPage() {
  try {
    const res = await fetch(urls?.album, {
      cache: 'no-store'
    })
    const data = await res.json()
    const gallery = Array.isArray(data?.data) ? data?.data : [];
    // cl("gallery", gallery)
    // console.log("gallery", gallery)

    return (
      <div className="bg-white">
        <main className="main">
          {/* breadcrumb */}
          <div
            className="site-breadcrumb"
            style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
          >
            <div className="container">
              <h2 className="breadcrumb-title">Gallery</h2>
              <ul className="breadcrumb-menu">
                <li>
                  <a href="/">Home</a>
                </li>
                <li className="active">Gallery</li>
              </ul>
            </div>
          </div>
          {/* breadcrumb end */}
          {/* gallery-area */}
          <div className="gallery-area py-100">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mx-auto">
                  <div
                    className="site-heading text-center wow fadeInDown"
                    data-wow-delay=".25s"
                  >
                    <span className="site-title-tagline">
                      <i className="fas fa-solar-panel" />
                      our Gallery
                    </span>
                    <h2 className="site-title">
                      Let's Check Our Photo <span>Gallery</span>
                    </h2>
                    <div className="heading-divider" />
                  </div>
                </div>
              </div>
              <AnimationWrapper animation="fade-up">
                <div className="row g-4 popup-gallery">
                  {Array.isArray(gallery) && gallery.length > 0 ? (
                    gallery.map((item, index) => (
                      <div className="col-md-3" key={index}>
                        <div className="gallery-item wow fadeInUp" data-wow-delay=".25s">
                          <div className="gallery-img">
                            {item?.image && (
                              <img
                                src={`${urls?.image}${item?.image}`}
                                alt={`Gallery image ${index}`}
                                className='img-fluid img-gallery'
                              />
                            )}
                          </div>
                          <div className="gallery-content">
                            {item?.image && (
                              <a
                                className="popup-img gallery-link"
                                href={`${urls?.image}${item?.image}`}
                              >
                                <i className="fal fa-plus" />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center">
                      <p>No gallery images available.</p>
                    </div>
                  )}
                </div>
              </AnimationWrapper>
            </div>
          </div>
          {/* gallery-area end */}
        </main>
        {/* scroll-top */}
        <a href="#" id="scroll-top">
          <i className="far fa-arrow-up" />
        </a>
        {/* scroll-top end */}
      </div>
    )
  } catch (error) {
    console.error("Error in Gallery Page:", error);
    return (
      <div className="container py-100">
        <div className="row">
          <div className="col-12 text-center">
            <h2>Unable to load gallery</h2>
            <p>Please try again later.</p>
          </div>
        </div>
      </div>
    );
  }
}